export type EventProperties = {
  minder_user_id: number;
};

export const getDefaultEventProperties = (id: number): EventProperties => ({
  minder_user_id: id,
});
